import React, { useState } from "react";

import { RegistrationFormProps } from "@/common/Outro/RegistrationForm";
import Pagination from "@/components/bild/Pagination";
import { Participant, RegistrationStatus } from "@/service/Model";

import DataOptIn from "./components/DataOptIn/DataOptIn";
import PersonalDetails from "./components/PersonalDetails/PersonalDetails";
import * as Styled from "./styles";

const LightRegistrationForm: React.FC<RegistrationFormProps> = (
  props: RegistrationFormProps
): React.JSX.Element => {
  const { onSubmit, registrationStatus, outro, hansId, hansIdExists } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [formData, setFormData] = useState<Partial<Participant>>({});

  const handleFormDataChange = (newData: Partial<Participant>) => {
    setFormData((prevData) => ({ ...prevData, ...newData }));
  };

  const handleSubmit = () => {
    if (onSubmit) {
      const participant = {
        ...formData,
        interactionType: "",
        interactionId: "",
      };
      onSubmit(participant);
    }
  };

  const onNext = () => {
    if (currentPage < pages.length) setCurrentPage(currentPage + 1);
  };

  const onBack = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const pages = [
    <PersonalDetails
      outro={outro}
      key="personalDetails"
      formData={formData}
      onChange={handleFormDataChange}
      onNext={onNext}
    />,
    <DataOptIn
      outro={outro}
      key="dataOptIn"
      formData={formData}
      onChange={handleFormDataChange}
      onBack={onBack}
      onSubmit={handleSubmit}
      hansId={hansId}
      hansIdExists={hansIdExists}
    />,
  ];

  const renderForm = (): React.JSX.Element => {
    return (
      <>
        <Styled.Header>{`Teilnehmen (${currentPage}/2)`}</Styled.Header>
        <Styled.PaginationWrapper>
          <Pagination currentPage={currentPage} />
        </Styled.PaginationWrapper>
        {pages[currentPage - 1]}
      </>
    );
  };

  const renderFormStatus = (): React.JSX.Element => {
    return (
      <Styled.Wrapper>
        <Styled.Header>Teilnehmerregistrierung</Styled.Header>
        <Styled.Checkmark />
        <Styled.Subheader>Vielen Dank für Ihre Teilnahme!</Styled.Subheader>
      </Styled.Wrapper>
    );
  };

  return (
    <>
      {!registrationStatus || registrationStatus === RegistrationStatus.None
        ? renderForm()
        : renderFormStatus()}
    </>
  );
};

export default LightRegistrationForm;
